export default __webpack_public_path__ + "static/media/logo_colour_320px.1c65e1a7.svg";